/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import FormField, {
  FormTextFieldProps
} from '../../../../client/js/components/form/fields/FormField'

function EmployerField (props: FormTextFieldProps) {
  const { name = 'employer', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      label={intl.formatMessage({
        id: 'employer',
        defaultMessage: 'Employeur'
      })}
      name={name}
      {...others}
    />
  )
}

export default EmployerField
